export default __webpack_public_path__ + "static/media/vp3_2025.a6047dfb.jpg";